import { render, staticRenderFns } from "./CommunicationResourceItem.vue?vue&type=template&id=e9f55748&"
import script from "./CommunicationResourceItem.vue?vue&type=script&lang=js&"
export * from "./CommunicationResourceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports